/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteMaintenanceReportCommandResult } from '../../models/delete-maintenance-report-command-result';

export interface ApiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Params {
  Id?: string;
}

export function apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete(http: HttpClient, rootUrl: string, params?: ApiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMaintenanceReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete.PATH, 'delete');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteMaintenanceReportCommandResult>;
    })
  );
}

apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete.PATH = '/api/ProjectMaintenanceReport/DeleteProjectMaintenanceReport';
